// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609211302/js/" + chunkId + "." + {"44":"6357d37b","225":"00bbe8ca","481":"8153d18c","486":"1c285fcb","770":"e533a01b"}[chunkId] + ".0.49788655774461077.chunk.js";
};